import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SubscriptionDuration, SubscriptionType } from '../../types/plan.types';
import { useAppQuery } from '../use-app-query.hook';

type GetSubscriptionResponse = {
  amount: number;
  currency: string;
  stakeholderLimit: number;
};

export const useSubscriptionData = ({
  companyId,
  type,
  frequency,
}: {
  companyId: string;
  frequency: SubscriptionDuration;
  type: SubscriptionType;
}) => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useAppQuery<GetSubscriptionResponse>({
    queryKey: [QueryKey.GET_SUBSCRIPTION_DATA, companyId, { type, frequency }],
    queryFn: () =>
      ApiService.get(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'subscription-data'] },
        {
          queryParams: {
            type,
            frequency,
          },
        },
      ),
    enabled: !!companyId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SUBSCRIPTION_DATA] });
  }, [queryClient]);

  return {
    data,
    isLoading,
    invalidateQuery,
  };
};
